import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

const MainCardTitle = ({ children, subtitle }) => (
    <Box sx={{ pb: 1, mb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 ,fontSize:'14px'}}>{children}</Typography>
        {subtitle && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>{subtitle}</Typography>
        )}
        <Divider sx={{ mt: 1 }} />
    </Box>
);

export default MainCardTitle;
